import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{format-range\n  @record.targetMinValue\n  @record.targetMaxValue\n  @record.targetUnit\n}}")